import React, { useState } from 'react';
import { Plus, Minus, Save, Printer, Edit2, Check, X } from 'lucide-react';

const EvaluationForm = () => {
  const [formLabels, setFormLabels] = useState({
    operatorName: 'Operator Name',
    trainingDate: 'Training Date',
    evaluationDate: 'Evaluation Date',
    evaluatorName: 'Evaluator Name',
    craneModel: 'Crane Model / Capacity',
    step: 'Step',
    evaluation: 'Evaluation',
    score: '*/10',
    pass: 'Pass',
    fail: 'Fail'
  });
  const [formTitle, setFormTitle] = useState("Evaluation of Training Form");

  const [editingLabel, setEditingLabel] = useState(null);
  const [tempLabelValue, setTempLabelValue] = useState('');
  const [printFormData, setPrintFormData] = useState(null);
  const [certificateDetails, setCertificateDetails] = useState({
    certificateNumber: '',
    certificateDate: ''
  });

  const [formData, setFormData] = useState({
    operatorName: '',
    trainingDate: '',
    evaluationDate: '',
    evaluatorName: '',
    craneModel: '',
    craneCapacity: '',
    craneLocation: '',
  });

  const [evaluationRows, setEvaluationRows] = useState([
    { step: '1. Pre-Operation Equipment Inspection', evaluation: 'Was operator able to read, identify and inspect Pre-Operational Checklist (Pre-Use Hoist, Crane and sling inspection Guidelines)', score: '7', pass: false, fail: false },
    { step: '2. Load Inspection', evaluation: 'Was the operator able to read and analysis weight of the load and SWL as not to exceed the rated capacity?', score: '10', pass: false, fail: false },
    { step: '2A. Load inspection', evaluation: 'Was the operator able to hoist an effective lift crane and secure the load properly, balanced and stable?', score: '', pass: false, fail: false },
    { step: '3. Move plan', evaluation: 'Was a destination clearly identified.', score: '', pass: false, fail: false },
    { step: '4. Control operation', evaluation: 'Was operator familiar with all controls on the pendant / Operation levers / Switches?', score: '', pass: false, fail: false },
    { step: '4A. Control operation', evaluation: 'Was load speed and control satisfactory? (no sudden stops or acceleration)', score: '', pass: false, fail: false },
    { step: '5. Safety Checks and inspection', evaluation: 'Was operator able to check the safety devices and limit switches and emergency stop use?', score: '', pass: false, fail: false },
    { step: '6 Crane Hand Signals', evaluation: 'Knowledge of Operator of Crane Hand Signals', score: '', pass: false, fail: false }
  ]);

  const [signatures, setSignatures] = useState({
    operatorSignature: '',
    eweEngineerSignature: '',
    safetyInChargeName: '',
    safetyInChargeSignature: '',
    clientCoordinatorName: '',
    clientCoordinatorSignature: ''
  });

  const [signatureLabels, setSignatureLabels] = useState({
    operatorSignature: 'Operator Signature',
    eweEngineerSignature: 'EWE-Engineer Signature',
    safetyInCharge: 'Safety In charge Name & Signature',
    clientCoordinator: 'Client Coordinator Name & Signature'
  });

  const [observationComments, setObservationComments] = useState('');
  const [observationLabel, setObservationLabel] = useState('OBSERVATION AND ENGINEER COMMENTS');
  const [officeUse, setOfficeUse] = useState('');
  const [officeUseLabel, setOfficeUseLabel] = useState('EAZYWORLD OFFICE USE');

  const startEditingLabel = (labelKey, currentValue) => {
    setEditingLabel(labelKey);
    setTempLabelValue(currentValue);
  };

  const saveLabel = (labelKey) => {
    if (labelKey.includes('signature')) {
      setSignatureLabels(prev => ({ ...prev, [labelKey]: tempLabelValue }));
    } else if (labelKey === 'observation') {
      setObservationLabel(tempLabelValue);
    } else if (labelKey === 'officeUse') {
      setOfficeUseLabel(tempLabelValue);
    } else {
      setFormLabels(prev => ({ ...prev, [labelKey]: tempLabelValue }));
    }
    setEditingLabel(null);
    setTempLabelValue('');
  };

  const cancelEditingLabel = () => {
    setEditingLabel(null);
    setTempLabelValue('');
  };

  const renderEditableLabel = (labelKey, currentValue, className = '') => {
    if (editingLabel === labelKey) {
      return (
        <div className={`flex items-center ${className}`}>
          <input
            type="text"
            value={tempLabelValue}
            onChange={(e) => setTempLabelValue(e.target.value)}
            className="form-control form-control-sm mr-2"
            autoFocus
          />
          <button
            onClick={() => saveLabel(labelKey)}
            className="btn btn-success btn-xs mr-1"
          >
            <Check size={12} />
          </button>
          <button
            onClick={cancelEditingLabel}
            className="btn btn-danger btn-xs"
          >
            <X size={12} />
          </button>
        </div>
      );
    }

    return (
      <div className={`flex items-center ${className}`}>
        <span className="font-weight-bold">{currentValue}:</span>
        <button
          onClick={() => startEditingLabel(labelKey, currentValue)}
          className="btn btn-link btn-xs p-0 ml-2 no-print"
        >
          <Edit2 size={12} />
        </button>
      </div>
    );
  };

  const handleFormDataChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleEvaluationChange = (index, field, value) => {
    setEvaluationRows(prev => prev.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    ));
  };

  const addEvaluationRow = () => {
    setEvaluationRows(prev => [...prev, {
      step: '',
      evaluation: '',
      score: '',
      pass: false,
      fail: false
    }]);
  };

  const removeEvaluationRow = (index) => {
    if (evaluationRows.length > 1) {
      setEvaluationRows(prev => prev.filter((_, i) => i !== index));
    }
  };

  const handleSignatureChange = (field, value) => {
    setSignatures(prev => ({ ...prev, [field]: value }));
  };

  const showToast = (type, title, message) => {
    // Create AdminLTE style toast notification
    const toastContainer = document.getElementById('toast-container') || (() => {
      const container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'position-fixed';
      container.style.cssText = 'top: 20px; right: 20px; z-index: 9999;';
      document.body.appendChild(container);
      return container;
    })();

    const toast = document.createElement('div');
    toast.className = `toast fade show border-0`;
    toast.setAttribute('role', 'alert');
    toast.innerHTML = `
      <div class="toast-header bg-${type} text-white border-0">
        <i class="fas fa-${type === 'success' ? 'check-circle' : 'exclamation-triangle'} mr-2"></i>
        <strong class="mr-auto">${title}</strong>
        <button type="button" class="ml-2 mb-1 close text-white" data-dismiss="toast">
          <span>&times;</span>
        </button>
      </div>
      <div class="toast-body bg-white">${message}</div>
    `;

    toastContainer.appendChild(toast);

    // Auto remove after 4 seconds
    setTimeout(() => {
      toast.classList.add('fade');
      setTimeout(() => toast.remove(), 300);
    }, 4000);

    // Manual close functionality
    toast.querySelector('.close').addEventListener('click', () => {
      toast.classList.add('fade');
      setTimeout(() => toast.remove(), 300);
    });
  };

  const validateForm = () => {
    const errors = [];

    if (!formData.operatorName.trim()) errors.push('Operator Name is required');
    if (!formData.evaluatorName.trim()) errors.push('Evaluator Name is required');
    if (!formData.trainingDate) errors.push('Training Date is required');
    if (!formData.evaluationDate) errors.push('Evaluation Date is required');

    const emptyEvaluations = evaluationRows.filter(row => !row.step.trim() || !row.evaluation.trim());
    if (emptyEvaluations.length > 0) {
      errors.push(`${emptyEvaluations.length} evaluation row(s) have empty step or evaluation fields`);
    }

    return errors;
  };

  const handlePrint = () => {
    const printContent = document.getElementById('printable-section');
    if (!printContent) return;

    const printWindow = window.open('', '', 'height=842,width=595'); // A4 size in points

    if (printWindow) {
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Evaluation Form</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 10mm;
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 11px;
              margin: 0;
              padding: 0;
            }

            .card {
              border: 2px solid #000;
              margin-bottom: 10px;
              padding: 6px;
            }

            .card-header,
            .card-footer,
            .card-body {
              padding: 6px;
            }

            .row {
              display: flex;
              flex-wrap: wrap;
            }

            .col-4, .col-6, .col-8, .col-12 {
              box-sizing: border-box;
              padding: 3px;
            }

            .col-4 { width: 33.33%; }
            .col-6 { width: 50%; }
            .col-8 { width: 66.66%; }
            .col-12 { width: 100%; }

            .bg-light {
              background-color: #f0f0f0;
              -webkit-print-color-adjust: exact;
            }

            textarea, input {
              border: none;
              background: none;
              font-size: 11px;
              width: 100%;
              resize: none;
              overflow: hidden;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 6px;
              font-size: 10px;
            }

            table, th, td {
              border: 1px solid #000;
              padding: 4px;
              text-align: left;
            }

            .text-center {
              text-align: center;
            }

            .font-weight-bold {
              font-weight: bold;
            }

            /* Avoid page breaks inside key sections */
            table, .no-break, .signatures-section, .footer-section {
              page-break-inside: avoid;
            }

            /* Reduce spacing to fit content */
            p, h3, h4 {
              margin: 4px 0;
            }

            /* Add minimal spacing before signature section */
            .signatures-section {
              margin-top: 20px;
            }

            /* Footer spacing */
            .footer-section {
              margin-top: 20px;
              text-align: center;
              font-size: 10px;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();

      // Optional: close window after print
      printWindow.close();
    }
  };


  const handleSave = async () => {
    // Show loading state
    const saveBtn = document.querySelector('.btn-save');
    if (saveBtn) {
      saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Saving...';
      saveBtn.disabled = true;
    }

    try {
      // Validate form
      const validationErrors = validateForm();
      if (validationErrors.length > 0) {
        showToast('warning', 'Validation Error', validationErrors.join('<br>'));
        return;
      }

      const payload = {
        form_type: 'eot',
        labels: formLabels,
        fields: [
          { label: 'Form Title', value: formTitle }, // ✅ include the title
          { label: formLabels.operatorName, value: formData.operatorName },
          { label: formLabels.trainingDate, value: formData.trainingDate },
          { label: formLabels.evaluationDate, value: formData.evaluationDate },
          { label: formLabels.evaluatorName, value: formData.evaluatorName },
          { label: formLabels.craneModel, value: formData.craneModel + ' / ' + formData.craneCapacity },
          { label: 'Crane Location', value: formData.craneLocation }
        ],
        questions: evaluationRows.map(row => ({
          step: row.step,
          evaluation: row.evaluation,
          score: row.score,
          pass: row.pass,
          fail: row.fail
        })),
        signatures: signatures,
        signatureLabels: signatureLabels,
        certificateNumber: certificateDetails.certificateNumber,
        certificateDate: certificateDetails.certificateDate,
        observationComments: observationComments,
        observationLabel: observationLabel,
        officeUse: officeUse,
        officeUseLabel: officeUseLabel,
        createdAt: new Date().toISOString()
      };

      const response = await fetch('https://api.eazyworldehsengineering.com/api/eval_form/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.ok) {
        showToast('success', 'Success', 'Form saved successfully! Form ID: ' + (responseData.id || 'N/A'));
        setPrintFormData(payload); // ✅ Store data for printing

        setTimeout(() => {
          handlePrint(); // ✅ Trigger print
        }, 1000);
        // Optionally reset form or redirect
        resetForm();
      } else {
        throw new Error(responseData.error || 'Failed to save form');
      }
    } catch (error) {
      console.error('Save Error:', error);
      showToast('danger', 'Error', `Failed to save form: ${error.message}`);
    } finally {
      // Reset button state
      if (saveBtn) {
        saveBtn.innerHTML = '<i class="fas fa-save mr-2"></i>Save Form';
        saveBtn.disabled = false;
      }
    }
  };

  const resetForm = () => {
    setFormData({
      operatorName: '',
      trainingDate: '',
      evaluationDate: '',
      evaluatorName: '',
      craneModel: '',
      craneCapacity: ''
    });
    setEvaluationRows([{
      step: '',
      evaluation: '',
      score: '',
      pass: false,
      fail: false
    }]);
    setSignatures({
      operatorSignature: '',
      eweEngineerSignature: '',
      safetyInChargeName: '',
      safetyInChargeSignature: '',
      clientCoordinatorName: '',
      clientCoordinatorSignature: ''
    });
    setCertificateDetails({
      certificateNumber: '',
      certificateDate: ''
    });
    setObservationComments('');
    setOfficeUse('');
    setFormTitle("Evaluation of Training Form")
    showToast('info', 'Form Reset', 'Form has been cleared for new entry');
  };

  const getValueFromFields = (label) => {
    const field = printFormData.fields.find(f => f.label === label);
    return field ? field.value : '';
  };



  return (
    <div className="content-wrapper">
      <style jsx>{`
        @media print {
          .no-print { display: none !important; }
          .content-wrapper { margin: 0; padding: 0; }
          .card { border: 2px solid #000 !important; box-shadow: none !important; }
          .table { font-size: 11px; }
          .form-control { border: none !important; }
        }
        .form-control:focus {
          border-color: #007bff;
          box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
        }
        .editable-label {
          cursor: pointer;
          border-bottom: 1px dashed #ccc;
        }
        .table-bordered td, .table-bordered th {
          border: 1px solid #000 !important;
        }
      `}</style>

      {/* Content Header */}
      <div className="content-header no-print">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Evaluation Form</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><a href="#">Home</a></li>
                <li className="breadcrumb-item active">Evaluation Form</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-primary">
            {/* Card Header */}
            <div className="card-header text-center bg-light">
              <div className="row align-items-center">
                <div className="col-2">
                  <img
                    src="/dist/img/eazylogo.png"
                    alt="Logo"
                    className="brand-image mr-2"
                    style={{ opacity: '.8' }}
                  />
                </div>
                <div className="col-10">
                  <h3 className="card-title font-weight-bold mb-1">EAZYWORLD EHS ENGINEERING PRIVATE LIMITED</h3>
                  <p className="mb-0 text-sm">ISO 9001-2015, 14002-2016 & 45001-2018 CERTIFIED COMPANY</p>
                </div>
              </div>
              <hr className="my-2" style={{ borderColor: '#000' }} />
              <div className="form-group">
                <label>Form Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={formTitle}
                  onChange={(e) => setFormTitle(e.target.value)}
                />
              </div>
            </div>

            {/* Card Body */}
            <div className="card-body p-0">
              {/* Basic Information */}
              <div className="row no-gutters">
                <div className="col-6" style={{ borderRight: '1px solid #000' }}>
                  <div className="p-3" style={{ borderBottom: '1px solid #000' }}>
                    <div className="form-group mb-2">
                      <div className="row align-items-center">
                        <div className="col-4 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('operatorName', formLabels.operatorName)}
                        </div>
                        <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={formData.operatorName}
                            onChange={(e) => handleFormDataChange('operatorName', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Enter operator name"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-0">
                      <div className="row align-items-center">
                        <div className="col-4 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('evaluatorName', formLabels.evaluatorName)}
                        </div>
                        <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={formData.evaluatorName}
                            onChange={(e) => handleFormDataChange('evaluatorName', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Enter evaluator name"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-4 bg-light p-2 mt-2" style={{ border: '1px solid #000' }}>
                        {renderEditableLabel('craneLocation', formLabels.craneLocation)}
                      </div>
                      <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                        <input
                          type="text"
                          className="form-control form-control-sm border-0"
                          value={formData.craneLocation}
                          onChange={(e) => handleFormDataChange('craneLocation', e.target.value)}
                          placeholder="Crane Location"
                        />
                      </div>
                    </div>
                  </div>

                </div>
                <div className="col-6">
                  <div className="p-3">
                    <div className="form-group mb-2">
                      <div className="row align-items-center">
                        <div className="col-4 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('trainingDate', formLabels.trainingDate)}
                        </div>
                        <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="date"
                            value={formData.trainingDate}
                            onChange={(e) => handleFormDataChange('trainingDate', e.target.value)}
                            className="form-control form-control-sm border-0"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-2">
                      <div className="row align-items-center">
                        <div className="col-4 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('evaluationDate', formLabels.evaluationDate)}
                        </div>
                        <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="date"
                            value={formData.evaluationDate}
                            onChange={(e) => handleFormDataChange('evaluationDate', e.target.value)}
                            className="form-control form-control-sm border-0"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group mb-0">
                      <div className="row align-items-center">
                        <div className="col-4 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('craneModel', formLabels.craneModel)}
                        </div>
                        <div className="col-8 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <div className="row no-gutters">
                            <div className="col-6">
                              <input
                                type="text"
                                value={formData.craneModel}
                                onChange={(e) => handleFormDataChange('craneModel', e.target.value)}
                                className="form-control form-control-sm border-0"
                                placeholder="Model"
                              />
                            </div>
                            <div className="col-6">
                              <input
                                type="text"
                                value={formData.craneCapacity}
                                onChange={(e) => handleFormDataChange('craneCapacity', e.target.value)}
                                className="form-control form-control-sm border-0"
                                placeholder="Capacity"
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Evaluation Table */}
              <div className="table-responsive">
                <table className="table table-bordered mb-0" style={{ border: '2px solid #000' }}>
                  <thead className="bg-light">
                    <tr>
                      <th className="text-center align-middle" style={{ width: '25%', border: '1px solid #000' }}>
                        {renderEditableLabel('step', formLabels.step)}
                      </th>
                      <th className="text-center align-middle" style={{ width: '40%', border: '1px solid #000' }}>
                        {renderEditableLabel('evaluation', formLabels.evaluation)}
                      </th>
                      <th className="text-center align-middle" style={{ width: '8%', border: '1px solid #000' }}>
                        {renderEditableLabel('score', formLabels.score)}
                      </th>
                      <th className="text-center align-middle" style={{ width: '8%', border: '1px solid #000' }}>
                        {renderEditableLabel('pass', formLabels.pass)}
                      </th>
                      <th className="text-center align-middle" style={{ width: '8%', border: '1px solid #000' }}>
                        {renderEditableLabel('fail', formLabels.fail)}
                      </th>
                      <th className="text-center align-middle no-print" style={{ width: '11%', border: '1px solid #000' }}>
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {evaluationRows.map((row, index) => (
                      <tr key={index}>
                        <td style={{ border: '1px solid #000' }}>
                          <textarea
                            value={row.step}
                            onChange={(e) => handleEvaluationChange(index, 'step', e.target.value)}
                            className="form-control form-control-sm border-0"
                            rows="2"
                            placeholder="Enter step"
                          />
                        </td>
                        <td style={{ border: '1px solid #000' }}>
                          <textarea
                            value={row.evaluation}
                            onChange={(e) => handleEvaluationChange(index, 'evaluation', e.target.value)}
                            className="form-control form-control-sm border-0"
                            rows="3"
                            placeholder="Enter evaluation criteria"
                          />
                        </td>
                        <td className="text-center" style={{ border: '1px solid #000' }}>
                          <input
                            type="text"
                            value={row.score}
                            onChange={(e) => handleEvaluationChange(index, 'score', e.target.value)}
                            className="form-control form-control-sm border-0 text-center"
                            placeholder="Score"
                          />
                        </td>
                        <td className="text-center" style={{ border: '1px solid #000' }}>
                          <input
                            type="checkbox"
                            checked={row.pass}
                            onChange={(e) => handleEvaluationChange(index, 'pass', e.target.checked)}
                            className="form-check-input"
                            style={{ transform: 'scale(1.2)' }}
                          />
                        </td>
                        <td className="text-center" style={{ border: '1px solid #000' }}>
                          <input
                            type="checkbox"
                            checked={row.fail}
                            onChange={(e) => handleEvaluationChange(index, 'fail', e.target.checked)}
                            className="form-check-input"
                            style={{ transform: 'scale(1.2)' }}
                          />
                        </td>
                        <td className="text-center no-print" style={{ border: '1px solid #000' }}>
                          <button
                            onClick={() => removeEvaluationRow(index)}
                            className="btn btn-danger btn-sm"
                            disabled={evaluationRows.length === 1}
                          >
                            <Minus size={14} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Add Row Button */}
              <div className="p-3 no-print">
                <button
                  onClick={addEvaluationRow}
                  className="btn btn-primary btn-sm"
                >
                  <Plus size={16} className="mr-1" />
                  Add Evaluation Row
                </button>
              </div>

              {/* Observation Section */}
              <div className="bg-light p-2" style={{ borderTop: '1px solid #000' }}>
                {renderEditableLabel('observation', observationLabel, 'font-weight-bold')}
              </div>
              <div className="p-3" style={{ minHeight: '100px' }}>
                <textarea
                  value={observationComments}
                  onChange={(e) => setObservationComments(e.target.value)}
                  className="form-control border-0"
                  rows="4"
                  placeholder="Enter observation and engineer comments..."
                />
              </div>

              {/* Signatures Section 
              <div className="row no-gutters" style={{ borderTop: '1px solid #000' }}>
                <div className="col-6" style={{ borderRight: '1px solid #000' }}>
                  <div className="p-3" style={{ borderBottom: '1px solid #000' }}>
                    <div className="form-group mb-2">
                      <div className="row align-items-center">
                        <div className="col-5 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('operatorSignature', signatureLabels.operatorSignature)}
                        </div>
                        <div className="col-7 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={signatures.operatorSignature}
                            onChange={(e) => handleSignatureChange('operatorSignature', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Operator signature"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="form-group mb-0">
                      <div className="row align-items-center">
                        <div className="col-5 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('safetyInCharge', signatureLabels.safetyInCharge)}
                        </div>
                        <div className="col-7 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={signatures.safetyInChargeName}
                            onChange={(e) => handleSignatureChange('safetyInChargeName', e.target.value)}
                            className="form-control form-control-sm border-0 mb-1"
                            placeholder="Name"
                          />
                          <input
                            type="text"
                            value={signatures.safetyInChargeSignature}
                            onChange={(e) => handleSignatureChange('safetyInChargeSignature', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Signature"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-3" style={{ borderBottom: '1px solid #000' }}>
                    <div className="form-group mb-2">
                      <div className="row align-items-center">
                        <div className="col-5 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('eweEngineerSignature', signatureLabels.eweEngineerSignature)}
                        </div>
                        <div className="col-7 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={signatures.eweEngineerSignature}
                            onChange={(e) => handleSignatureChange('eweEngineerSignature', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Engineer signature"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="form-group mb-0">
                      <div className="row align-items-center">
                        <div className="col-5 bg-light p-2" style={{ border: '1px solid #000' }}>
                          {renderEditableLabel('clientCoordinator', signatureLabels.clientCoordinator)}
                        </div>
                        <div className="col-7 p-2" style={{ border: '1px solid #000', borderLeft: 'none' }}>
                          <input
                            type="text"
                            value={signatures.clientCoordinatorName}
                            onChange={(e) => handleSignatureChange('clientCoordinatorName', e.target.value)}
                            className="form-control form-control-sm border-0 mb-1"
                            placeholder="Name"
                          />
                          <input
                            type="text"
                            value={signatures.clientCoordinatorSignature}
                            onChange={(e) => handleSignatureChange('clientCoordinatorSignature', e.target.value)}
                            className="form-control form-control-sm border-0"
                            placeholder="Signature"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Office Use Section */}
              <div className="bg-light p-2" style={{ borderTop: '1px solid #000' }}>
                {renderEditableLabel('officeUse', officeUseLabel, 'font-weight-bold')}
              </div>
              <div className="p-3" style={{ minHeight: '80px' }}>
                <textarea
                  value={officeUse}
                  onChange={(e) => setOfficeUse(e.target.value)}
                  className="form-control border-0"
                  rows="3"
                  placeholder="Office use only..."
                />
              </div>

              {/* Certificate Details */}
              <div className="row p-3">
                <div className="col-md-6">
                  <label><strong>Certificate Number:</strong></label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="e.g., BPD/EWE-EHS/PRAC-EVAL/01/029/2122"
                    value={certificateDetails.certificateNumber}
                    onChange={(e) =>
                      setCertificateDetails({ ...certificateDetails, certificateNumber: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label><strong>Certificate Date:</strong></label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={certificateDetails.certificateDate}
                    onChange={(e) =>
                      setCertificateDetails({ ...certificateDetails, certificateDate: e.target.value })
                    }
                  />
                </div>
              </div>

              {/* Footer 
              <div className="text-center p-3 small" style={{ borderTop: '1px solid #000' }}>
                <div className="row">
                  <div className="col-6">
                    <strong>VERIFIED BY</strong>
                  </div>
                  <div className="col-6">
                    <strong>APPROVED BY</strong>
                  </div>
                </div>
                <div className="mt-4">
                  <p className="mb-1"><strong>BPD/EWE-EHS/PRAC-EVAL/01/03/2122 – Date -23-12-2022 Controlled copy</strong></p>
                  <p className="mb-0"><strong>Approved By : Santhosh Keasaveran</strong></p>
                </div>
              </div> */}

            </div>

            {/* Card Footer */}
            <div className="card-footer no-print">
              <div className="row">
                <div className="col-md-3">
                  <button
                    onClick={handleSave}
                    className="btn btn-success btn-save"
                  >
                    <i className="fas fa-save mr-2"></i>
                    Save Form
                  </button>
                </div>
                <div className="col-md-3">
                  <button
                    onClick={resetForm}
                    className="btn btn-warning"
                  >
                    <i className="fas fa-undo mr-2"></i>
                    Reset Form
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {printFormData && (
        <div id="printable-section" style={{ display: "none", fontFamily: 'Arial, sans-serif', fontSize: '14px', padding: '20px' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '100px' }}>
              <img src="/dist/img/eazylogo.png" alt="Logo" style={{ height: '60px' }} />
            </div>
            <div style={{ flexGrow: 1, textAlign: 'center' }}>
              <h3 style={{ margin: 0 }}>EAZYWORLD EHS ENGINEERING PRIVATE LIMITED</h3>
              <p style={{ margin: 0 }}>ISO 9001-2015, 10002-20186, 45001-2018 CERTIFIED COMPANY</p>
              <h4 style={{ marginTop: '10px', textDecoration: 'underline' }}>
                {getValueFromFields('Form Title')}
              </h4>
            </div>
          </div>

          {/* Basic Details */}
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
            <tbody>
              <tr>
                <td>Operator Name:</td>
                <td>{getValueFromFields('Operator Name')}</td>
                <td>Training Date:</td>
                <td>{getValueFromFields('Training Date')}</td>
              </tr>
              <tr>
                <td>Evaluator Name:</td>
                <td>{getValueFromFields('Evaluator Name')}</td>
                <td>Evaluation Date:</td>
                <td>{getValueFromFields('Evaluation Date')}</td>
              </tr>
              <tr>
                <td>Crane Model / Capacity:</td>
                <td>{getValueFromFields('Crane Model / Capacity')}</td>
                <td>Crane Location:</td>
                <td>{getValueFromFields('Crane Location')}</td>
              </tr>
            </tbody>
          </table>

          {/* Evaluation Table */}
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }} border="1">
            <thead>
              <tr style={{ background: '#eee' }}>
                <th>Step</th>
                <th>Evaluation</th>
                <th>Score</th>
                <th>Pass</th>
                <th>Fail</th>
              </tr>
            </thead>
            <tbody>
              {printFormData.questions.map((row, index) => (
                <tr key={index}>
                  <td>{row.step}</td>
                  <td>{row.evaluation}</td>
                  <td>{row.score}</td>
                  <td style={{ textAlign: 'center' }}>{row.pass ? '✔️' : ''}</td>
                  <td style={{ textAlign: 'center' }}>{row.fail ? '❌' : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Observation */}
          <div style={{ marginTop: '20px' }}>
            <strong>{printFormData.observationLabel || 'OBSERVATION AND ENGINEER COMMENTS:'}</strong>
            <div style={{ border: '1px solid #000', minHeight: '40px', marginTop: '5px', padding: '5px' }}>
              {printFormData.observationComments}
            </div>
          </div>

          {/* Signatures */}
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }} border="1">
            <thead style={{ backgroundColor: '#f0f0f0' }}>
              <tr>
                <th style={{ width: '50%', textAlign: 'center' }}>Operator Signature</th>
                <th style={{ width: '50%', textAlign: 'center' }}>EWE-Engineer Signature</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ height: '30px', verticalAlign: 'top', padding: '4px', fontSize: '12px' }}></td>
                <td style={{ height: '30px', verticalAlign: 'top', padding: '4px', fontSize: '12px' }}></td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center' }}>Safety In charge<br />Name & Signature</th>
                <th style={{ textAlign: 'center' }}>Client Coordinator<br />Name & Signature</th>
              </tr>
              <tr>
                <td style={{ height: '30px', verticalAlign: 'top', padding: '4px', fontSize: '12px' }}></td>
                <td style={{ height: '30px', verticalAlign: 'top', padding: '4px', fontSize: '12px' }}></td>
              </tr>
            </tbody>
          </table>

          {/* Office Use Section */}
          <div style={{ marginTop: '20px' }}>
            <strong>{printFormData.officeUseLabel || 'EAZYWORLD OFFICE USE:'}</strong>
            <div style={{ border: '1px solid #000', minHeight: '60px', marginTop: '5px', padding: '5px' }}>
              {printFormData.officeUse}
            </div>
          </div>

          {/* Verified & Approved Signature Section (Print-only) */}
          <div style={{ marginTop: '40px', padding: '10px 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '45%', textAlign: 'center' }}>
                <strong>VERIFIED BY</strong>
                <div style={{ height: '60px', marginTop: '5px' }}></div>
              </div>
              <div style={{ width: '45%', textAlign: 'center' }}>
                <strong>APPROVED BY</strong>
                <div style={{ height: '60px', marginTop: '5px' }}></div>
              </div>
            </div>
          </div>

          {/* Footer Certificate Number and Date */}
          <div style={{ textAlign: 'center', fontSize: '12px', marginTop: '30px' }}>
            <p><strong>{printFormData.certificateNumber || 'BPD/EWE-EHS/PRAC-EVAL/01/029/2122'} – Date - {printFormData.certificateDate || '23-12-2022'} Controlled copy</strong></p>
            <p><strong>Approved By - Santhosh Koteeswaran</strong></p>
          </div>

        </div>
      )}


    </div>
  );
};

export default EvaluationForm;